import PropTypes from 'prop-types'
import React, { useEffect, useState } from 'react'
import useFetchSections from '/src/hooks/api/fetch_sections'
import CreationInspectionModel from '/src/models/creation_inspection'
import InspectionModel from '/src/models/inspection'
import Form from '/src/ui/core/forms/form'
import FormButtons from '/src/ui/core/forms/form_buttons'
import FormWrapper from '/src/ui/core/forms/form_wrapper'
import includeGeneralSection from '/src/ui/domain/eav_sections/include_general_section'
import inspectedFormatter from '/src/ui/domain/inspections/inspected_formatter'
import InspectionStatusLabel from '/src/ui/domain/inspections/inspection_status_label'
import '/src/static/css/domain/inspections/inspection_form.css'
import i18n from 'i18n-js'
import { useStore } from 'react-context-hook'
import ActionButton from '../../core/buttons/action_button'
import CancelButton from '../../core/buttons/cancel_button'
import prepareDuplicatedInspection from '/src/src/utils/prepareDuplicatedInspection'

export default function InspectionForm({ dataItem, templateId, type }) {
  const sections = useFetchSections(templateId)
  const [globalSubproject] = useStore('subproject')
  const customFormatter = (item) => {
    const { inspected = {}, inspected_type: inspectedType } = item
    return inspectedFormatter(inspected, inspectedType)
  }
  const buildModel = () =>
    type === 'new' ? new CreationInspectionModel() : new InspectionModel(customFormatter)
  const [model, setModel] = useState(buildModel())
  const [haveRecurrence, setHaveRecurrence] = useState(false)
  const [step, setStep] = useState(2)
  const [includeOnForm, setIncludeOnForm] = useState({})
  const [dataItemForForm, setDataItemForForm] = useState(dataItem)
  const readOnlyColumns = ['request_id', 'inspected_type']
  const readOnlyTypes = ['attachment', 'picture']
  const isDuplicate = () => type === 'duplicate'
  const isCreation = () => type === 'new'

  const disabledColumns = (column) => {
    let result = readOnlyColumns.includes(column.description)

    if (isDuplicate() || isCreation()) {
      result = result || readOnlyTypes.includes(column.type)
    }
    return result
  }

  function handleButtonClick(type) {
    setHaveRecurrence(type === 'yes' ? true : false)
    setStep(2)
  }

  useEffect(() => {
    if (dataItem && dataItem.inspected_id) {
      setIncludeOnForm({ eav_template_id: templateId, inspected_id: dataItem.inspected_id })
    } else setIncludeOnForm({ eav_template_id: templateId })
  }, [dataItem])

  useEffect(() => {
    const model = buildModel()

    const newModel = {
      ...model,
      columns: model.columns.map((column) => {
        if (
          haveRecurrence &&
          (column.description === 'frequency_interval' || column.description === 'recurrence_type')
        ) {
          return {
            ...column,
            hideOnForm: false,
            required: true
          }
        }
        return column
      })
    }
    setModel(newModel)
  }, [haveRecurrence, step])

  useEffect(() => {
    if (type === 'duplicate' && dataItem && sections) {
      const duplicatedInspection = prepareDuplicatedInspection(dataItem, model, sections)
      setDataItemForForm(duplicatedInspection)
    }
  }, [dataItem, sections, type, model])

  useEffect(() => {
    if (globalSubproject.automatic_inspection && type === 'new') {
      setHaveRecurrence(true)
      setStep(1)
    }
  }, [])

  //TODO - melhorar isso depois
  const formReady = () => (
    <FormWrapper
      model={model}
      dataItem={dataItem}
      label={dataItem && dataItem.request_id}
      badge={dataItem && <InspectionStatusLabel dataItem={dataItem} />}
      type={type}
      sidePanelSections={includeGeneralSection(sections)}
    >
      {step === 1 && (
        <div className="form-wrapper-subtitle">
          <div style={{ marginTop: '40px' }}>
            <p>{i18n.t('inspections.recurrence_question')}</p>
            <div
              style={{
                display: 'flex',
                justifyContent: 'space-between',
                alignItems: 'center',
                gap: '10px'
              }}
            >
              <ActionButton
                onClick={() => handleButtonClick('yes')}
                title={i18n.t('actions.yes')}
              />
              <CancelButton onClick={() => handleButtonClick('no')} title={i18n.t('actions.no')} />
            </div>
          </div>
        </div>
      )}
      {step === 2 && (
        <>
          <Form
            key="main-form"
            model={model}
            sections={sections}
            dataItem={dataItemForForm}
            includeOnForm={includeOnForm}
            templateId={templateId}
            type={isDuplicate() ? 'new' : type}
            disableColumnEdition={disabledColumns}
          />
          <FormButtons model={model} awaitFormSuccess />
        </>
      )}
    </FormWrapper>
  )

  return formReady()
}

InspectionForm.propTypes = {
  dataItem: PropTypes.shape({
    inspected: PropTypes.object,
    inspected_type: PropTypes.string
  }),
  templateId: PropTypes.number.isRequired,
  type: PropTypes.string.isRequired
}

InspectionForm.defaultProps = {
  dataItem: {
    inspected: {},
    inspected_type: 'Request'
  }
}
